// Prod Config
const ClientConfig = {
  conversionURL: "https://api.infra3d.com/conversion/",
  shibboClientId: "2n42lde6slrcibg5bj9bnf0d16",
  shibboDomain: "https://auth-classic.infra3d.com",
  loginURL: "https://api.infra3d.com/login/",
  logoutURL: window.location.origin + "/",
  framerURL: "https://api.infra3d.com/framer/",
  framegateURL: "https://api.infra3d.com/framegate/",
  geocoderURL: "https://api.infra3d.com/geocoder/",
  geofeatureserverURL: "https://api.infra3d.com/geofeatureserver/",
  mistraaxisloaderURL: "https://api.infra3d.com/mistraaxisloader/",
  linrefcodeURL: "https://api.infra3d.com/linrefcode/",
  pileURL: "https://api.infra3d.com/pile/",
  pilegateURL: "https://api.infra3d.com/pilegate/",
  stargateURL: "https://xxts716ql2.execute-api.eu-west-1.amazonaws.com/prod/",
  lidargateURL: "https://api.infra3d.com/lidargate/",
  stage: "prod",
  notMigrated: [
    "eu-west-1_SZ4EJaLQd", // infra3dnextgen-classic
    "eu-west-1_iylZ5L4xo", // infra3dnextgen-trial
  ],
};
export default ClientConfig;
